import React, { forwardRef, memo } from 'react'

import { util } from '../../../util'

const TableHeadCell = ({ align, size, className, children, layout, ...rest }, ref) => (
    <th
        ref={ref}
        data-testid={'table-row__cell'}
        className={util.joinClasses('table-row__cell', layout, align, size, className)}
        {...rest}
    >
        {children}
    </th>
)

export default memo(forwardRef(TableHeadCell))
